<template>
  <div>
    <div class="nav-link">
      <el-link href="/#/dealer/login" icon="el-icon-s-marketing"
        >商家登录</el-link
      >
      <el-link href="/#/shop/login" icon="el-icon-s-shop">门店登录</el-link>
    </div>
    <div class="banner">
      <div v-if="bannerVisible" style="background: #f8f8f8">
        <el-carousel :interval="5000" arrow="always" height="200px">
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <a
              class="banner-item"
              :style="`background-image:url(${item.imgUrl});`"
              :href="item.linkUrl"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <el-form
      v-if="!logined"
      :model="formData"
      :rules="rules"
      ref="formData"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <h3 class="title">员工登录</h3>
      <el-form-item prop="phone">
        <el-input
          size="small"
          type="text"
          v-model="formData.phone"
          auto-complete="off"
          placeholder="账号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          size="small"
          type="password"
          v-model="formData.password"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-checkbox v-model="checked" checked class="remember"
          size="small"
        >记住密码</el-checkbox
      >
      <el-form-item style="width: 100%">
        <el-button
          size="small"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleSubmit"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
    <p>
      &nbsp;
    </p>
    <!-- <el-dialog :visible.sync="bannerVisible" width="100%" fullscreen>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bannerVisible = false"
          >关闭({{ closeCountdown }}秒)</el-button
        >
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      logined: true,
      formData: {
        deviceId: null,
        phone: "",
        password: "",
      },
      rules: {
        phone: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      checked: true,
      bannerList: [],
      bannerVisible: false,
      closeSeconds: 10,
      closeCountdown: 10,
    };
  },
  created: function () {
    document.title = "员工登录";
    let logout = this.$route.query.logout;
    this.formData.deviceId = this.$route.query.id;
    this.api.staff
      .status({})
      .then((response) => {
        if (!response.data.errorCode && response.data.data) {
          this.$store.commit({
            type: "loginIn",
            name: response.data.data.name,
            userName: response.data.data.phone,
            id: response.data.data.id,
            token: response.data.data.token,
          });
          this.$router.replace({ path: "main", query: this.getQuery() });
        } else {
          //if (this.isWeiXin() && !logout) {
          //  this.wxMpLogin();
          //} else {
          this.logined = false;
          this.$store.commit("logout");
          //}
        }
      })
      .catch((error) => {
        this.logined = false;
      });

    this.getBanner();
  },
  methods: {
    wxMpLogin() {
      let code = this.$route.query.code;
      if (code) {
        this.api.staff
          .wxMpAuthLogin({
            deviceId: this.$route.query.id,
            code: code,
          })
          .then((response) => {
            if (response.data.errorCode == 0 && response.data.data) {
              this.$store.commit({
                type: "loginIn",
                name: response.data.data.name,
                userName: response.data.data.phone,
                id: response.data.data.id,
                token: response.data.data.token,
              });
              this.$router.replace({ path: "main", query: this.getQuery() });
            } else {
              this.logined = false;
              this.$store.commit("logout");
            }
          });
      } else {
        this.api.staff
          .getWxMpAuthUrl({
            deviceId: this.$route.query.id,
            redirectUri:
              location.origin +
              `/staff/wx/mp/auth/code/${this.$route.query.id}`,
          })
          .then((response) => {
            if (!response.data.errorCode && response.data.data != null) {
              location.href = response.data.data;
            } else {
              this.logined = false;
              this.$store.commit("logout");
            }
          });
      }
    },
    handleSubmit(ev) {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.api.staff
            .login(Object.assign({}, this.formData))
            .then((response) => {
              if (response.data.errorCode == 0) {
                this.$store.commit({
                  type: "loginIn",
                  name: response.data.data.name,
                  userName: response.data.data.phone,
                  id: response.data.data.id,
                  token: response.data.data.token,
                });
                this.$router.replace({ path: "main", query: this.getQuery() });
              }
            });
        } else {
          return false;
        }
      });
    },
    getQuery() {
      let query = Object.assign({}, this.$route.query);
      query.code = undefined;
      query.logout = undefined;
      return query;
    },
    getBanner() {
      this.api.staff
        .listBanner({ deviceId: this.formData.deviceId })
        .then((response) => {
          if (!response.data.errorCode && response.data.data) {
            this.bannerList = response.data.data;
            if (this.bannerList.length > 0) {
              this.bannerVisible = true;
              //this.startCountdown();
            }
          }
        });
    },
    startCountdown() {
      this.closeCountdown = this.closeSeconds;
      var intervalId = setInterval(() => {
        this.closeCountdown = this.closeCountdown - 1;
        if (this.closeCountdown <= 0) {
          clearInterval(intervalId);
          //this.bannerVisible = false;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.login-container {
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  width: 300px;
  padding: 10px;
  border-radius: 5px;
  background-clip: padding-box;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  margin: 15px auto;
}

.title {
  margin: 6px auto;
  text-align: center;
  color: #505458;
  font-size: 18px;
}

.remember {
  margin: 0px 0px 20px 0px;
}
.nav-link {
  font-size: 20px;
  text-align: right;
  padding: 5px 10px;
}
.nav-link >>> a {
  font-size: 15px;
  margin-left: 5px;
}
.banner {
  margin: 5px 10px;
  min-height: 70px;
}
.banner-item {
  display: inline-block;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>


// WEBPACK FOOTER //
// Login.vue?7486dff2